module.exports = __webpack_public_path__ + "img/2.182cdec6.jpg";